export function FreelanceImage() {
    return (
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_48_121)">
                <circle cx="60" cy="60" r="50" fill="#1991FF" />
                <path d="M69.8 49.8L65.7 44.6H91.3L69.8 49.8Z" fill="white" />
                <path d="M64.4 44.6L58 49.8H68.4L64.4 44.6Z" fill="white" />
                <path d="M30.8 48.8L56.5 49.8L47.4 67.1L30.8 48.8Z" fill="white" />
                <path d="M48.1 67.9L57.2 50.6H69.1L66.2 68.2L56.5 77.1L48.1 67.9Z" fill="white" />
                <path d="M42.8 48.5L54 48.8L40.9 43.7L42.8 48.5Z" fill="white" />
                <path d="M55.8 77.8L49.1 70.4L44.5 88.7L55.8 77.8Z" fill="white" />
            </g>
            <defs>
                <filter
                    id="filter0_d_48_121"
                    x="0"
                    y="0"
                    width="120"
                    height="120"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_48_121" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_48_121"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}
